import "./init.js";
import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "mobx-react";
import App from "./App";
import userStore from "./store/userStore";
import sessionStore from "./store/sessionStore";
import profileStore from "./store/profileStore";
import hatsStore from "./store/hatsStore";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { PostHogProvider } from "posthog-js/react";

export { graphQLClient } from "./graphqlClient";

const options = {
  api_host: "https://ph.hatsandladders.com/",
  ui_host: "https://us.posthog.com",
  defaults: "2025-05-24",
};

import "./locales/i18n.js";

const stores = { userStore, sessionStore, profileStore, hatsStore };

export const queryClient = new QueryClient();

// Set up persistence
const localStoragePersister = createSyncStoragePersister({
  storage: window.localStorage,
});

persistQueryClient({
  queryClient,
  persister: localStoragePersister,
  maxAge: 1000 * 60 * 60 * 24, // 24 hours
});

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PostHogProvider
      /* Post hog public API key is safe to share publicly */
      apiKey="phc_j6Nh0282Y2u8gJgddhb7KNyQ4FZ4GJ1ufCrI9VNZbyj"
      options={options}
    >
      <QueryClientProvider client={queryClient}>
        <Provider {...stores}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
        {window.location.hostname === "localhost" && (
          <ReactQueryDevtools
            initialIsOpen={false}
            buttonPosition="bottom-left"
          />
        )}
      </QueryClientProvider>
    </PostHogProvider>
  </React.StrictMode>,
);
